export const LIST_MOVIE_REQUEST = "listMovieReducer/LIST_MOVIE_REQUEST";
export const LIST_MOVIE_SUCCESS = "listMovieReducer/LIST_MOVIE_SUCCESS";
export const LIST_MOVIE_FAILED = "listMovieReducer/LIST_MOVIE_FAILED";
